// CommonJS format instead of ES6 modules
const ACCESS_TYPE = 'ws'; // ws or sse 标志链接方式
const APP_KEY = "";

// Welcome message configuration
const configs = {
    // Default welcome message
    default: {
        serverPath: 'aichat.netnotary.cn/api',
        title: 'Hi~杭州互联网公证处',
        subtitle: '您好！我是杭州互联网公证处可以为您提供7×24小时全天候服务的智能咨询小助手。我是一个基于人工智能大模型的智能体（AI Agent），已经学习了不少法律法规、公证知识以及实务案例，可以回答有关公证各方面的常见问题。尽管我还在继续学习，但您的问题我都会竭尽所能来帮助您。请问有什么可以帮到您？',
        clientId: 'hanghu',
        avatar: 'https://qidian-qbot-1251316161.cos.ap-guangzhou.myqcloud.com/public/1942556148986959424/1949804711190513984/image/HdJKKUOnrquenDGbTyjT-1949804993281555136.png',
        bgEnabled: false,
        defaultQuestions: [
            '杭州互联网公证处可以办理哪些业务？',
            '杭州互联网公证处人工服务的联系方式？',
            '哪些业务可以在线办理？',
            '怎么通过线上申请办理公证？需要登录哪个网站或下载什么APP？'
        ],
        questionTree: null
    },
    local: {
        serverPath: 'aichat.netnotary.cn/api',
        title: 'Hi~杭州互联网公证处',
        subtitle: '您好！我是杭州互联网公证处可以为您提供7×24小时全天候服务的智能咨询小助手。我是一个基于人工智能大模型的智能体（AI Agent），已经学习了不少法律法规、公证知识以及实务案例，可以回答有关公证各方面的常见问题。尽管我还在继续学习，但您的问题我都会竭尽所能来帮助您。请问有什么可以帮到您？',
        clientId: 'hanghu',
        avatar: 'https://qidian-qbot-1251316161.cos.ap-guangzhou.myqcloud.com/public/1936959060936260288/1949657199350676160/image/RrTypeHoGNgUKkexotEu-1949657245186676288.png',
        bgEnabled: false,
        defaultQuestions: [
            '杭州互联网公证处可以办理哪些业务？',
            '杭州互联网公证处人工服务的联系方式？',
            '哪些业务可以在线办理？',
            '怎么通过线上申请办理公证？需要登录哪个网站或下载什么APP？'
        ],
        questionTree: null
    }
};

function getSubdomain() {
    // if localhost, return local
    if (window.location.hostname === 'localhost') {
        return 'local';
    }
    const hostnameParts = window.location.hostname.split('.');
    // Assumes structure is subdomain.domain.tld or subdomain.app.domain.tld
    // If your domain structure is different, adjust this logic.
    if (hostnameParts.length > 2) {
        return hostnameParts[0];
    }
    return 'default'; // Or whatever your main app's identifier is
}

const subdomain = typeof window !== 'undefined' ? getSubdomain() : 'default';

// Export the configuration for the current subdomain, or the default
const config = configs[subdomain] || configs.default;
// CommonJS exports instead of ES6 exports
module.exports = {
    ACCESS_TYPE,
    APP_KEY,
    config
};



// WEBPACK FOOTER //
// ./src/constants/static.js